import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { SelectLanguageDialogComponent } from '../select-language-dialog/select-language-dialog.component';
import { BlockedContentService } from '../../../services/blocked-content.service';

@Component({
  selector: 'nr-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  public adsLink;

  constructor(public dialog: MatDialog, private blockedContentService: BlockedContentService) {
    this.adsLink = environment.headerLinks.googleAds;
  }

  onStartClick() {
    this.dialog.open(SelectLanguageDialogComponent, {});
  }

  onLinkClick() {
    const newWin = window.open(this.adsLink);
    this.blockedContentService.showWarningMessage(newWin);
  }
}
